export default __webpack_public_path__ + "static/media/HICL.e94c8fbc.png";